import type { CoverFieldKey } from './types';

// Dialog ids live here rather than beside their dialogs: the cart action opens
// them, and importing a dialog's folder for its id would pull the dialog in.
export const CUSTOMIZE_DIALOG_ID = 'print-order-customize';
export const LOCATION_DIALOG_ID = 'print-order-location';

export const COVER_FIELD_KEYS: CoverFieldKey[] = [
  'ContactName',
  'ContactTitle',
  'PhoneNumber',
  'EmailAddress',
  'Website'
];
